export default "<footer class=\"footer\">\n\n</footer>\n"